module.exports = __webpack_public_path__ + "img/blood-pressure-log_B09M4T7PB1.45c649c8.jpg";